import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { PfandrechtBelastungMasterDetailEntryMeta, PfandrechtBelastungVersionDetailEntryMeta } from '../../../core/gb-api';
import { HistoryDirective } from '../../directives/history.directive';
import { KompaktGrundstueckComponent } from '../grundstueck/kompakt-grundstueck.component';
import { KompaktBelegComponent } from '../beleg/kompakt-beleg.component';
import { BetragPipe } from '../../pipes/simple/betrag.pipe';
import { DatumPipe } from '../../pipes/simple/datum.pipe';
import { TranslateNamePipe } from '../../pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-kompakt-pfandrecht-belastung',
  templateUrl: 'kompakt-pfandrecht-belastung.component.html',
  imports: [
    NgTemplateOutlet,
    HistoryDirective,
    KompaktGrundstueckComponent,
    TranslatePipe,
    KompaktBelegComponent,
    BetragPipe,
    DatumPipe,
    TranslateNamePipe
  ]
})
export class KompaktPfandrechtBelastungComponent extends KompaktdarstellungTemplateComponent {
  @Input()
  belastungMaster: PfandrechtBelastungMasterDetailEntryMeta;

  @Input()
  belastung: PfandrechtBelastungVersionDetailEntryMeta;

  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;
  @ViewChild('typ01', { static: true }) typ01Template: TemplateRef<any>;

  constructor(
    formatService: FormatConfigService,
    public translate: TranslateService,
    location: PlatformLocation,
    locationStrategy: ComponentLocationStrategy
  ) {
    super(formatService, 'GRUNDPFANDRECHTBELASTUNG', location, locationStrategy);
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'GRUNDPFANDRECHTBELASTUNG_TYP00');
    this.bindTemplates(this.typ01Template, 'GRUNDPFANDRECHTBELASTUNG_TYP01');
  }
}
